var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "nps-scale"
  }, [_c('span', [_vm._v(_vm._s(_vm.options[0] && _vm.options[0].title))]), _c('div', {
    staticClass: "options-box ml-10"
  }, _vm._l(_vm.options, function (option, index) {
    return _c('span', {
      key: option.option_id,
      staticClass: "options-item",
      style: {
        background: index <= _vm.selectIndex ? "linear-gradient(to right, rgba(255, 126, 0, " + (index ? index : 1) / _vm.options.length + "), rgba(255, 126, 0, " + (index + 1) / _vm.options.length + "))" : ''
      },
      on: {
        "click": function ($event) {
          return _vm.handleClick(option.option_id);
        }
      }
    }, [_vm._v(_vm._s(option.value))]);
  }), 0), _c('div'), _c('span', [_vm._v(_vm._s(_vm.options[_vm.options.length - 1] && _vm.options[_vm.options.length - 1].title))])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };